import { datadogRum } from "@datadog/browser-rum";

if (process.env.NODE_ENV === "production") {
  datadogRum.init({
    applicationId: "f2499bb9-70ef-4635-9d4a-4c24966408d3",
    clientToken: "pubf598783e4f0aef2f0701185b6cbae26c",
    site: "datadoghq.com",
    service: "insights-prod",
    env: "prod",
    version: "20261026",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
  });
}
